import { getCookiesForPurchaseAttribution } from '@shared/tracking';
import type { CartResponse, CartTicket, CheckoutTicketMeta } from '../types';

function getOrderCompletedProductType(ticketMeta?: CheckoutTicketMeta) {
  if (!ticketMeta) return undefined;
  if (ticketMeta.hunt) return 'hunt';
  if (ticketMeta.subscription) return 'subscription';
  return 'duration';
}

function mapTicketToOrderCompletedProduct(ticket: CartTicket, attribution: Record<string, string>, type?: 'hunt' | 'subscription' | 'duration') {
  const amount = ticket.price / 100;

  if (ticket.type === 'LOTTO') {
    return {
      genre: 'Lotto',
      productId: ticket.lotteryId,
      lines: ticket.lines.length,
      duration: ticket.lifespan.duration,
      amount,
      ...attribution,
      ...(type ? { type } : {}),
    };
  }

  return {
    genre: 'Scratchcard',
    productId: ticket.name,
    quantity: ticket.quantity,
    amount,
    ...attribution,
  };
}

function getOrderCompletedPayload(response: CartResponse, currency: string, ticketMeta?: CheckoutTicketMeta) {
  const attribution = getCookiesForPurchaseAttribution();
  const type = getOrderCompletedProductType(ticketMeta);

  return {
    orderId: String(response.orderId),
    orderAmount: response.stake / 100,
    bonusAmount: response.bonusDiscount / 100,
    currency,
    products: response.tickets.map(ticket => mapTicketToOrderCompletedProduct(ticket, attribution, type)),
  };
}

export { getOrderCompletedPayload };
